import * as React from 'react';
import { Participant, SchoolEvent } from 'Src/models/event';
import { EVENT_RESULTS_MODE } from 'Src/consts/event';
import { getEventSportType } from 'Src/helpers/accessor/accessor';
import {
  getParticipantTeamResult,
  getParticipantTeamResultNumber,
  isEventStatusFinished,
  isTeamOrTwoOnTwoSportEvent
} from 'Src/helpers/event/event';
import {
  getAbbreviationColor,
  getAbbreviationResultBySchoolId,
  getAbbreviationResultByTeamId,
  getExtraPointsBySchoolId,
  getExtraPointsByTeamId
} from 'Src/helpers/event/schoolEventViewHelper';
import './ParticipantResultBadge.scss';

interface Props {
  event: SchoolEvent;
  participant: Participant;
}

function resultPrefix(event: SchoolEvent): string {
  switch (event.resultsMode) {
    case EVENT_RESULTS_MODE.PLACES:
      return 'Place: ';
    case EVENT_RESULTS_MODE.POINTS:
      return 'Points: ';
    default:
      return '';
  }
}

export const ParticipantResultBadge = ({ event, participant }: Props) => {
  const isTeamSport = getEventSportType(event) === 'TEAM';
  const teamResult = isTeamSport ? getParticipantTeamResult(event, participant) : '';
  const teamResultNumber = isTeamSport ? getParticipantTeamResultNumber(event, participant) : 0;
  const isVisible = isEventStatusFinished(event) && isTeamSport && (teamResult !== '' || teamResultNumber > 0);
  if (!isVisible) return null;

  const schoolId = participant.school && participant.school.id;
  const extraPoints = participant.team
    ? getExtraPointsByTeamId(event, participant.team.id)
    : schoolId
    ? getExtraPointsBySchoolId(event, schoolId)
    : 0;
  const abbreviationResult = participant.team
    ? getAbbreviationResultByTeamId(event, participant.team.id)
    : schoolId
    ? getAbbreviationResultBySchoolId(event, schoolId)
    : '';
  const abbreviationColor = getAbbreviationColor(event, abbreviationResult);
  const textResult = isTeamOrTwoOnTwoSportEvent(event) ? resultPrefix(event) : '';

  return (
    <div className="ePlayerScore__badge">
      <strong>
        {textResult} {teamResult}
      </strong>
      {extraPoints > 0 && <span>Points: {extraPoints}</span>}
      {abbreviationResult && (
        <span className="ePlayerScore__abbreviation" style={{ color: abbreviationColor }}>
          {abbreviationResult}
        </span>
      )}
    </div>
  );
};
